
class productTracklist extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.currentTrack = null;
        this.addToPlaylistButton = null;

        this.addToPlaylistButton = this.querySelector('.addToPlaylist');
        this.addToPlaylistButton.addEventListener("click", this.addToPlaylist.bind(this));

        this.tracks = this.querySelectorAll('.tracklist__item');
        this.tracks.forEach((track) => {
            track.addEventListener('click', this.playMiniPlayer.bind(this));
        })

        window.addEventListener('changeVolume', (event) => {
            if(!window.wavesurferInstance) return;
            window.wavesurferInstance.setVolume(localStorage.getItem('volume'));
        })

        this.playlistOpenEvent = new CustomEvent('togglePlaylist', {'detail': {
            isPlaylistOpen: true,
        }});
    }

    disconnectedCallback() {
        if(window.wavesurferInstance) window.wavesurferInstance.destroy();
        this.addToPlaylistButton.removeEventListener("click", this.addToPlaylist.bind(this));
        this.tracks.forEach((track) => {
            track.removeEventListener('click', this.playMiniPlayer.bind(this));
        })
    }

    addToPlaylist(e) {
        e.stopImmediatePropagation();
        let tracklist = [];
        let playlist;

        let trackNodes = this.querySelectorAll('.tracklist__item');

        // Select the mtn-product-tracks element and access its shadowRoot
        const productTracksElement = this.querySelector('mtn-product-tracks');
        
        if (!productTracksElement || !productTracksElement.shadowRoot) {
           console.error('mtn-product-tracks or its shadowRoot not found');
        } else {
            // Use shadowRoot to query for .tracklist__item elements
            trackNodes = productTracksElement.shadowRoot.querySelectorAll('.tracklist__item');
        }

        console.log(trackNodes);
       
       
        if (!trackNodes || !trackNodes.length) {
           console.error('.tracklist__item elements not found in shadow DOM');
           return;
        }

        trackNodes.forEach((track) => {
            tracklist.push({
                id: track.dataset.id,
                title: track.dataset.title,
                preview: track.dataset.preview,
                label: track.dataset.album_label,
                label_url: track.dataset.album_label_url,
                artist: track.dataset.album_artist,
                album: track.dataset.album,
                album_id: track.dataset.album_id,
                album_cover: track.dataset.album_cover,
                album_title: track.dataset.album_title,
                product_url: track.dataset.product_url,
                duration: track.dataset.duration,
                is_available: (track.dataset.is_available === "true"),
            })
        })
        playlist = JSON.parse(localStorage.getItem('playlist')) || [];

        // if(localStorage.getItem('currentSong') === null || window.wavesurferMainInstance.isPlaying() === false) {
            localStorage.setItem('currentSong', JSON.stringify(tracklist[0]));
            window.dispatchEvent(new Event('changeSong'));
        // }

        if(window.wavesurferMainInstance.isPlaying() === false) {
            window.wavesurferMainInstance.on('ready', () => {
                setTimeout(() => {
                    window.wavesurferMainInstance.play().then(r => r);
                }, 100)
            })
        }

        const currentPlaylistItem = playlist.find((item) => item['album_id'] === trackNodes[0].dataset.album_id);
        if(playlist && currentPlaylistItem) {
            // Following line opens the playlist
            // window.dispatchEvent(this.playlistOpenEvent);

            const el = document.createElement('toast-notification');
            el.setAttribute('type','success');

            const content = document.createTextNode('Release already in playlist');
            el.appendChild(content);
            document.getElementById('MainContent').appendChild(el);
            return;
        }

        playlist.unshift({
            album_id: trackNodes[0].dataset.album_id,
            album_cover: trackNodes[0].dataset.album_cover,
            album_title: trackNodes[0].dataset.album_title,
            label: trackNodes[0].dataset.album_label,
            label_url: trackNodes[0].dataset.album_label_url,
            product_url: trackNodes[0].dataset.product_url,
            available: trackNodes[0].dataset.is_available,
            tracks: tracklist,
        })
        localStorage.setItem('playlist', JSON.stringify(playlist));

        // Following line opens the playlist
        // window.dispatchEvent(this.playlistOpenEvent);

        window.dispatchEvent(new Event('playlistUpdated'));
    }

    playMiniPlayer(event) {
        event && event.stopImmediatePropagation();
        if(window.wavesurferMainInstance) window.wavesurferMainInstance.pause();
        window.wavesurferMainInstance.on('play', function() {
            document.querySelectorAll('.tracklist__item').forEach((track) => {
                track.querySelector('p').classList.remove('active');
                track.querySelector('p').classList.remove('paused');
                track.querySelector('.js-is-paused').classList.add('hidden');
                track.querySelector('.js-is-playing').classList.remove('hidden');
            })
        })

        this.tracks.forEach((track) => {
            track.querySelector('.js-is-playing').classList.remove('hidden');
            track.querySelector('.js-is-paused').classList.add('hidden');
        })
        this.currentTrack = event.target;
        if(this.currentTrack.classList.contains('active')) {
            this.currentTrack.classList.remove('active');
            this.currentTrack.classList.add('paused');
            this.currentTrack.querySelector('.js-is-paused').classList.add('hidden');
            this.currentTrack.querySelector('.js-is-playing').classList.remove('hidden');
            window.wavesurferInstance.playPause();
            return
        } else if(this.currentTrack.classList.contains('paused')) {
            this.currentTrack.classList.remove('paused');
            this.currentTrack.classList.add('active');
            this.currentTrack.querySelector('.js-is-paused').classList.remove('hidden');
            this.currentTrack.querySelector('.js-is-playing').classList.add('hidden');
            window.wavesurferInstance.playPause();
            return
        } else {
            this.tracks.forEach((track) => {
                track.querySelector('p').classList.remove('active');
                track.querySelector('p').classList.remove('paused');
            })
            this.currentTrack.querySelector('.js-is-paused').classList.remove('hidden');
            this.currentTrack.querySelector('.js-is-playing').classList.add('hidden');
            this.currentTrack.classList.add('active');
        }
        const trackContainer = event.target.closest('.js-track');
        const track = trackContainer.querySelector('.tracklist__item');

        const trackInfo = {
            elem: trackContainer,
            id: track.dataset.id,
            title: track.dataset.title,
            preview: track.dataset.preview,
            artist: track.dataset.album_artist,
            label: track.dataset.album_label,
            label_url: track.dataset.album_label_url,
            album: track.dataset.album,
            album_id: track.dataset.album_id,
            album_cover: track.dataset.album_cover,
            album_title: track.dataset.album_title,
            duration: track.dataset.duration,
        }
        this.loadMiniPlayer(trackInfo)
    }

    loadMiniPlayer(track) {
        track.elem.querySelector('.loading').classList.remove('hidden');
        window.wavesurferOptions.container = track.elem.querySelector('.mini-player');
        let options = window.wavesurferOptions;
    
        // Determine the height based on the viewport width
        options.height = window.innerWidth >= 1280 ? 32 : 48;
    
        if(window.wavesurferInstance) window.wavesurferInstance.destroy();
        window.wavesurferInstance = WaveSurfer.create(options);
        window.wavesurferInstance.load(track.preview); // Alternative: loadBlob (more: https://wavesurfer.xyz/docs/classes/wavesurfer.default#loadBlob)
        window.wavesurferInstance.on('ready', () => {
            window.wavesurferInstance.setVolume(localStorage.getItem('volume') || 0.5);
            track.elem.querySelector('.loading').classList.add('hidden');
            track.elem.querySelector('.mini-player').classList.remove('hidden');
            window.wavesurferInstance.play();
        })
        window.wavesurferInstance.on('finish', () => {
            track.elem.querySelector('.js-is-paused').classList.add('hidden');
            track.elem.querySelector('.js-is-playing').classList.remove('hidden');
            track.elem.querySelector('p').classList.remove('active');
            track.elem.querySelector('p').classList.add('paused');
        })
    }
}

customElements.define('product-tracklist', productTracklist);

document.addEventListener('tooltip:close', function(e){
    if(e.target.dataset.toolTip === "QuickShop") {
        if(window.wavesurferInstance) window.wavesurferInstance.destroy();
    }
});
